import { Map as map } from 'immutable';
const C = require("../constants");

function PlanReducer(state = map(), action) {
    switch (action.type) {
        case C.SELECT_PLAN:
            return action.plan;
        default:
            return state;
    }
};

export default PlanReducer;


// WEBPACK FOOTER //
// ./src/reducers/PlanReducer.js